/* ==========================================================================
   Bold Movement — bm-ambassador.js
   Ambassador page behavior. Ship as: theme/assets/bm-ambassador.js
   - UGC yes/no conditional reveal
   - smooth-scroll for "See how it works"
   ========================================================================== */

(function () {
  'use strict';

  var form = document.querySelector('[data-amb-form]');
  if (form) {
    var step1 = form.querySelector('[data-amb-step="1"]');
    var step2 = form.querySelector('[data-amb-step="2"]');
    var nextBtn = form.querySelector('[data-amb-next]');
    var backBtn = form.querySelector('[data-amb-back]');

    function showStep(n) {
      if (step1) step1.hidden = (n !== 1);
      if (step2) step2.hidden = (n !== 2);
      // scroll the form header into view so user sees the next step
      var anchor = document.getElementById('register');
      if (anchor) {
        var y = anchor.getBoundingClientRect().top + window.pageYOffset - 24;
        window.scrollTo({ top: y, behavior: 'smooth' });
      }
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        // Validate only the visible step-1 fields before advancing
        var required = step1 ? step1.querySelectorAll('input[required], textarea[required]') : [];
        var valid = true;
        required.forEach(function (el) {
          if (!el.checkValidity()) {
            el.reportValidity();
            valid = false;
          }
        });
        if (valid) showStep(2);
      });
    }

    if (backBtn) {
      backBtn.addEventListener('click', function () { showStep(1); });
    }

    // UGC yes/no toggle (within step 2)
    var yesPanel = form.querySelector('[data-amb-ugc-yes]');
    var noPanel = form.querySelector('[data-amb-ugc-no]');

    form.querySelectorAll('input[name="ugc_interest"]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        var yes = radio.value === 'yes' && radio.checked;
        if (yesPanel) yesPanel.hidden = !yes;
        if (noPanel) noPanel.hidden = yes;
        var ta = yesPanel && yesPanel.querySelector('textarea');
        if (ta) ta.required = yes;
      });
    });
  }

  document.querySelectorAll('[data-amb-scroll]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var target = document.querySelector(a.getAttribute('href'));
      if (!target) return;
      e.preventDefault();
      var y = target.getBoundingClientRect().top + window.pageYOffset - 24;
      window.scrollTo({ top: y, behavior: 'smooth' });
    });
  });
})();
